import {useSelector} from 'react-redux'
import {adminRoleId} from '../../../Utils/permission'

/**
 * Custom hook for checking Health page access restrictions
 * Returns true when an admin (chargeback admin panel) is viewing a business account's health page and is not allowed to see real data
 */
const useHealthAccessRestricted = () => {
  const isAdmin = useSelector(state => state.auth.isAdmin)
  const roleId = useSelector(state => state.auth.userInfo?.role?.id)
  return isAdmin && roleId === adminRoleId
}

export default useHealthAccessRestricted
